import gql from "graphql-tag";

export const FLASH_CAMPAIGN = gql`
  query flashCampaign($id: ID!) {
    flashCampaign(id: $id) {
      id
      isPublished
      product {
        id
      }
      campaignContent
    }
  }
`;
